<ng-template #content_print_qrcode let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.barcode">
        <div class="side_popup_header">
            <span>{{localService.languageContent.barcode.header}}</span>
            <span class="en">&nbsp;-&nbsp;{{title}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" [ngStyle]="{'max-height' : (localService.sideBarBodyHeight - 10) + 'px'}">
            <div *ngIf="labelsTop" class="banner" style="margin: 10px;">
                <div *ngFor="let item of labelsTop;index as i">
                    <div class="row">
                        <div class="col-6">
                            <app-label [Text]="localService.languageContent.barcode.label_top"
                                [IsColonRequired]="false"></app-label>
                            <span class="en">&nbsp;({{i+1}})</span>
                        </div>
                        <div class="col-6">
                            <ngx-select [isFocused]="true" [(ngModel)]="item.key" [noAutoComplete]="true"
                                [items]="localService.Sort(localService.languagesEquivalent,true,'v3')"
                                [optionValueField]="'v1'" [optionTextField]="'v3'"></ngx-select>
                        </div>
                    </div>
                    <div>
                        <div class="col-12">
                            <input autocomplete="off" type="text" [(ngModel)]="item.value"
                                ngbTooltip="{{localService.languageContent.barcode.label_top}}"
                                placeholder="{{localService.languageContent.barcode.label_top}}"
                                [ngClass]="item.value ? localService.getLanguageCode(item.key) : ''" />
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="labelsBottom" class="banner" style="margin: 10px;">
                <div *ngFor="let item of labelsBottom;index as i">
                    <div class="row">
                        <div class="col-6">
                            <app-label [Text]="localService.languageContent.barcode.label_bottom"
                                [IsColonRequired]="false"></app-label>
                            <span class="en">&nbsp;({{i+1}})</span>
                        </div>
                        <div class="col-6">
                            <ngx-select [isFocused]="true" [(ngModel)]="item.key" [noAutoComplete]="true"
                                [items]="localService.Sort(localService.languagesEquivalent,true,'v3')"
                                [optionValueField]="'v1'" [optionTextField]="'v3'"></ngx-select>
                        </div>
                    </div>
                    <div>
                        <div class="col-12">
                            <input autocomplete="off" type="text" [(ngModel)]="item.value"
                                ngbTooltip="{{localService.languageContent.barcode.label_bottom}}"
                                placeholder="{{localService.languageContent.barcode.label_bottom}}" 
                                [ngClass]="item.value ? localService.getLanguageCode(item.key) : ''"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="banner" style="margin: 10px;">
                <div class="row">
                    <div class="col-7" style="text-align: right;">
                        <app-label [Text]="localService.languageContent.barcode.bar_code_size"
                            [IsMandatory]="true"></app-label>
                    </div>
                    <div class="col-5">
                        <input autocomplete="off" type="number" class="number" [ngClass]="barCodeSize ? 'en' : ''"
                            style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
                            [(ngModel)]="barCodeSize"
                            placeholder="*{{localService.languageContent.barcode.bar_code_size}}"
                            ngbTooltip="*{{localService.languageContent.barcode.bar_code_size}}"
                            (blur)="onSaveLastUsedSettings()" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-7" style="text-align: right;">
                        <app-label [Text]="localService.languageContent.barcode.paper_width"
                            [IsMandatory]="true"></app-label>
                    </div>
                    <div class="col-5">
                        <input autocomplete="off" type="number" class="number" [ngClass]="paperWidth ? 'en' : ''"
                            style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
                            [(ngModel)]="paperWidth" placeholder="*{{localService.languageContent.barcode.paper_width}}"
                            ngbTooltip="*{{localService.languageContent.barcode.paper_width}}" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-7" style="text-align: right;">
                        <app-label [Text]="localService.languageContent.barcode.paper_height"
                            [IsMandatory]="true"></app-label>
                    </div>
                    <div class="col-5">
                        <input autocomplete="off" type="number" class="number" [ngClass]="paperHeight ? 'en' : ''"
                            style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
                            [(ngModel)]="paperHeight"
                            placeholder="*{{localService.languageContent.barcode.paper_height}}"
                            ngbTooltip="*{{localService.languageContent.barcode.paper_height}}" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-7" style="text-align: right;">
                        <app-label [Text]="localService.languageContent.barcode.font_size_top"
                            [IsMandatory]="true"></app-label>
                    </div>
                    <div class="col-5">
                        <input autocomplete="off" type="number" class="number" [ngClass]="fontSizeTop ? 'en' : ''"
                            style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
                            [(ngModel)]="fontSizeTop"
                            placeholder="*{{localService.languageContent.barcode.font_size_top}}"
                            ngbTooltip="*{{localService.languageContent.barcode.font_size_top}}" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-7" style="text-align: right;">
                        <app-label [Text]="localService.languageContent.barcode.font_size_bottom"
                            [IsMandatory]="true"></app-label>
                    </div>
                    <div class="col-5">
                        <input autocomplete="off" type="number" class="number" [ngClass]="fontSizeBottom ? 'en' : ''"
                            style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
                            [(ngModel)]="fontSizeBottom"
                            placeholder="*{{localService.languageContent.barcode.font_size_bottom}}"
                            ngbTooltip="*{{localService.languageContent.barcode.font_size_bottom}}" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-7" style="text-align: right;">
                        <app-label [Text]="localService.languageContent.barcode.color_code"
                            [IsMandatory]="true"></app-label>
                    </div>
                    <div class="col-4">
                        <input autocomplete="off" type="text" [(ngModel)]="colorCode" [ngClass]="colorCode ? 'en' : ''"
                            ngbTooltip="{{localService.languageContent.barcode.color_code}}"
                            placeholder="{{localService.languageContent.barcode.color_code}}" maxlength="6" />
                    </div>
                    <div class="col-1">
                        <a href="https://htmlcolorcodes.com/" target="_blank">
                            <button class="button_icon button_icon_color icon_adjust" style="margin-left: -20px;"
                                ngbTooltip="{{localService.languageContent.barcode.color_code}}">color_lens</button>
                        </a>
                    </div>
                </div>
            </div>
            <div class="box center" style="width: fit-content;" *ngIf="barcodeValue">
                <div *ngFor="let item of labelsTop" style="text-align: center;"
                    [ngStyle]="{'font-size':'18px','color':'#'+colorCode}">
                    <div class="row" *ngIf="item.value">
                        <span [ngClass]="localService.getLanguageCode(item.key)">{{item.value}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" style="text-align: center;">
                        <qrcode [qrdata]="barcodeValue" [width]="200" [errorCorrectionLevel]="'H'"></qrcode>
                    </div>
                </div>
                <div *ngFor="let item of labelsBottom" style="text-align: center;"
                    [ngStyle]="{'font-size':'15px','color':'#'+colorCode}">
                    <div class="row" *ngIf="item.value">
                        <span [ngClass]="localService.getLanguageCode(item.key)">{{item.value}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="side_popup_footer">
            <div class="row">
                <div class="col-12" style="text-align: right;">
                    <button type="button" class="btn btn-primary" id="{{elementIds.qr_code_save}}"
                        (click)="onAction(1)">{{localService.languageContent.barcode.print}}</button>
                </div>
            </div>
        </div>
    </div>
    <div id="{{elementIds.qr_code_container}}" style="display: none;">
        <qrcode [qrdata]="barcodeValue" [width]="barCodeSize" [errorCorrectionLevel]="'H'"></qrcode>
    </div>
    <app-print *ngIf="IsPrint" [printWidth]="paperWidth" [fileName]="FileName" [content]="printContent"
        (onPrinted)="onPrintedBarcode()"></app-print>
</ng-template>